"use client";

import { PrivacyNotice } from "../sections/PrivacyNotice";
import { Shell } from "./Shell";

/** `/privacy` beneath the client boundary (`WEB-019`). See `DisclosureView` for why. */
export function PrivacyView() {
  return (
    <Shell honorableMentions>
      <PrivacyNotice />
    </Shell>
  );
}
